import * as THREE from 'three';

/** World units per hex (sim fixed 1000). */
export const WORLD_PER_HEX = 1.2;
const K = WORLD_PER_HEX / 1000;

/** Sim fixed (x, y) → three.js (X, Z). Y is up. */
export const simToWorld = (x: number, y: number, out = new THREE.Vector3(), h = 0): THREE.Vector3 => out.set(x * K, h, y * K);
export const worldToSim = (v: THREE.Vector3): { x: number; y: number } => ({ x: Math.round(v.x / K), y: Math.round(v.z / K) });
/** Sim facing angle (0..1023, atan2(dy, dx)) → rotation around Y for a model facing +Z. */
export const facingToRotY = (a: number): number => Math.PI / 2 - (a / 1024) * Math.PI * 2;

/** Scale applied to miniatures so a 1.8-unit hero stands about 0.95 units on a 1.2-unit hex. */
export const SCALE = {
  hero: 0.6,
  enemy: 0.56,
  boss: 0.95,
  tower: 0.62,
  wall: 0.66,
  keep: 0.9,
  support: 0.62,
  trap: 0.7,
  turret: 0.55,
  golem: 0.6,
};
